import React from 'react';
import Spacing from '../common/Spacing';

const LabelledCountRow: React.FunctionComponent = ({ children }) => {
  return (
    <div className="labelled-count-row">
      {React.Children.map(children, (child) => {
        return <Spacing right={3}>{child}</Spacing>;
      })}
      {/*language=CSS*/}
      <style jsx>{`
        .labelled-count-row {
          display: flex;
        }
      `}</style>
    </div>
  );
};

export default LabelledCountRow;
